// Trix-Konfiguration für deutsche Übersetzungen über Rails i18n
import Trix from "trix"

// Lade Übersetzungen aus Rails i18n (werden in Layout eingefügt)
document.addEventListener('DOMContentLoaded', function() {
  // Prüfe ob window.translations.trix existiert (von Rails i18n)
  if (window.translations && window.translations.trix) {
    console.log('Loading Trix translations from Rails i18n:', window.translations.trix)
    Object.entries(window.translations.trix).forEach(([key, value]) => {
      if (Trix && Trix.config && Trix.config.lang) {
        Trix.config.lang[key] = value
        console.log(`  Trix.config.lang.${key} = "${value}"`)
      }
    })
  } else {
    // Fallback: Direkte deutsche Übersetzungen
    console.warn('window.translations.trix not found, using fallback translations')
    if (Trix && Trix.config && Trix.config.lang) {
      Trix.config.lang.remove = "Entfernen"
      Trix.config.lang.captionPlaceholder = "Beschriftung hinzufügen…"
      Trix.config.lang.urlPlaceholder = "URL eingeben…"
    }
  }
})

export default {}
